/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ page: NonNullable<unknown>, totalPages: NonNullable<unknown> }} Table_Page_OfInputs */

const en_table_page_of = /** @type {(inputs: Table_Page_OfInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Page ${i?.page} of ${i?.totalPages}`)
};

const pt_br2_table_page_of = /** @type {(inputs: Table_Page_OfInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Página ${i?.page} de ${i?.totalPages}`)
};

/**
* | output |
* | --- |
* | "Page {page} of {totalPages}" |
*
* @param {Table_Page_OfInputs} inputs
* @param {{ locale?: "en" | "pt-BR" }} options
* @returns {LocalizedString}
*/
export const table_page_of = /** @type {((inputs: Table_Page_OfInputs, options?: { locale?: "en" | "pt-BR" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Table_Page_OfInputs, { locale?: "en" | "pt-BR" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_table_page_of(inputs)
	return pt_br2_table_page_of(inputs)
});